import React from 'react';
import AppPage from '../common/AppPage';

function ScriptsPage() {
  return (
    <AppPage pageClass="scripts-page">
      <div className="scripts">
        <h5>WoTMud Scripts</h5>
        <div className="mt-4 row">
          <div className="col-xl-8">
            <ul>
              <li>
                <p>
                  <a href="wotcodeapi.mpackage">Data Collection</a> <span className="text-muted">(WotCodeAPI)</span>
                </p>
                <p>
                  This package collects stats, equipment, and smob load data while you play the game.
                  The collected data gets fed back to this site for public consumption and analysis.
                </p>
                <p>
                  <strong className="fw-600">Instructions for use:</strong>
                  <ol>
                    <li>Carry the target item in your inventory.</li>
                    <li>Type <b>app</b> to appraise the item, for example <b>app sword</b>.</li>
                    <li>The item will uploaded to this site.  Refresh your browser to see new items.</li>
                    <li>Optionally, type <b>editeq</b> to make further adjustments to the equipment.</li>
                  </ol>
                </p>
                <p>
                  <strong className="fw-600 me-2">Last Updated:</strong>12-31-2023<br/>
                  <strong className="fw-600 me-2">Change Notes:</strong>Fixed bug that could occassionaly prevent the data capture commands from completing.<br/>
                  <strong className="fw-600 me-2">Client:</strong>Mudlet
                </p>
              </li>
              <li>
                <p>
                  <a href="ways.mpackage">Ways Traversal</a>
                </p>
                <p>
                  This package helps you travel through the Ways.
                </p>
                <p>
                  <strong className="fw-600">Instructions for use:</strong>
                  <ol>
                    <li>Type <b>ways help</b> to view options in game.</li>
                  </ol>
                </p>
                <p>
                  <strong className="fw-600 me-2">Last Updated:</strong>10-29-2024<br/>
                  <strong className="fw-600 me-2">Change Notes:</strong>Initial release<br/>
                  <strong className="fw-600 me-2">Client:</strong>Mudlet
                </p>
              </li>
              <li>
                <p>
                  <a href="sorted_list.mpackage">Sorted List for Clan Chest</a>
                </p>
                <p>
                  This package provides an organized view of your clan chest, with click to withdraw functionality.
                </p>
                <p>
                  <strong className="fw-600">Instructions for use:</strong>
                  <ol>
                    <li>Go to clan chest room and type <b>slist</b> (short for sorted list).</li>
                  </ol>
                </p>
                <p>
                  <strong className="fw-600 me-2">Last Updated:</strong>11-07-2024<br/>
                  <strong className="fw-600 me-2">Change Notes:</strong>Initial release<br/>
                  <strong className="fw-600 me-2">Client:</strong>Mudlet
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </AppPage>
  );
}

export default ScriptsPage;